import styled, { css } from 'styled-components';

type StatusTone = 'success' | 'warning' | 'neutral';
const STATUS_MAP: Record<StatusTone, { bg: string; color: string }> = {
  success: { bg: '#e6f3ec', color: '#006633' },
  warning: { bg: '#fff4e0', color: '#b45309' },
  neutral: { bg: '#f1f5f9', color: '#475569' },
};

export const StatusBadge = styled.span<{ $tone: StatusTone }>`
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  ${({ $tone }) => css`
    background: ${STATUS_MAP[$tone].bg};
    color: ${STATUS_MAP[$tone].color};
  `}
`;

export const IconButton = styled.button<{ $danger?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #475569;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;

  & + & {
    margin-left: 6px;
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    ${({ $danger }) =>
      $danger
        ? css`
            background: #fef2f2;
            border-color: #b91c1c;
            color: #b91c1c;
          `
        : css`
            background: #f8fafc;
            border-color: #006633;
            color: #006633;
          `}
  }
`;

export const CreateButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 14px;
  border-radius: 10px;
  border: 1px solid transparent;
  background: #006633;
  color: #ffffff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover {
    background: #00451f;
  }
`;
